let closeBtn = document.getElementById('close-overlay');

if ( closeBtn ){
    closeBtn.addEventListener('click', () => {
        const target = document.getElementById("overlay-img");
        target.remove();
    });
}